import { apiRequest } from './index';

export const fetchEmployeeTypeRequest = ( id, success = (result = []) => {}, failure = (error) => {}) => {
    apiRequest('/employee-types/' + id, {}, success, failure);
}

export const fetchEmployeeTypesRequest = ( success = (result = []) => {}, failure = (error) => {}) => {
    apiRequest('/employee-types', {}, success, failure);
}

export const createEmployeeTypeRequest = ( data, success = (result = []) => {}, failure = (error) => {}) =>{
    apiRequest(
        '/employee-types',
        { 
            method: 'POST',
            body: JSON.stringify(data)
        },
        success,
        failure
    )
}

export const editEmployeeTypeRequest = ( id, data, success = (result = []) => {}, failure = (error) => {}) =>{
    apiRequest(
        '/employee-types/' + id,
        { 
            method: 'PUT',
            body: JSON.stringify(data)
        },
        success,
        failure
    )
}

const buildEmployeeTypeOptions = employeeType => ({
    value: employeeType ? employeeType._id : '',
    label: employeeType ? employeeType.employeeTypeName : '',
    data: employeeType
});

export const employeeTypeSelectOptionRequest = (success = (result = []) => {}, failure = (error) => {}) =>{
    fetch(process.env.REACT_APP_API_ENDPOINT + '/employee-types')
        .then(response => response.json())
        .then(data => {
            const selectOptions = [];
            data.forEach((item) => {
                const option = buildEmployeeTypeOptions(item);
                selectOptions.push(option);
            });
            success(selectOptions);
        })
        .catch(error =>{
            failure(error.status);
        });
}

export const deleteEmployeeTypeRequest = ( id, success = (result = []) => {}, failure = (error) => {}) =>{
    apiRequest(
        '/employee-types/' + id,
        { method: 'DELETE' },
        success,
        failure
    )
}
